import { FormikHelpers } from "formik";
import { useCreateAtmServiceProvider } from "./api/createAtmServiceProvider";
import AtmServiceProviderForm from "./AtmServiceProviderForm";


const CreateAtmServiceProvider = ({handleCloseModal}: CreateServiceProviderProps)  => {
  const createAtmServiceProviderMutation = useCreateAtmServiceProvider({data: {}});

  const initialValues: IPostNewAtmServiceProvider = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewAtmServiceProvider, { setSubmitting }: FormikHelpers<IPostNewAtmServiceProvider>): Promise<void> => {
    try {
      await createAtmServiceProviderMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AtmServiceProviderForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateServiceProviderProps {
  handleCloseModal: () => void;
}

export default CreateAtmServiceProvider;